import { DateTime } from 'luxon';
import { UiSpaBookingDTO, UiSpaTicketDTO } from '@api';

export class BookingUtils {
  static getBookingStatus(booking?: UiSpaBookingDTO, tickets?: UiSpaTicketDTO[]): BookingStatus {
    if (!booking) return BookingStatus.done;

    if (booking.cancellationId !== null && booking.cancellationId !== undefined) {
      return BookingStatus.canceled;
    }

    if (booking && !tickets) {
      const maxDate = DateTime.max(...booking.tickets.map((ticket: UiSpaTicketDTO) => DateTime.fromISO(ticket.toDate)));
      const now = DateTime.now();

      if (!maxDate || maxDate < now) {
        return BookingStatus.done;
      } else {
        return BookingStatus.open;
      }
    }

    if (tickets) {
      const maxDate = DateTime.max(...tickets.map((ticket) => DateTime.fromISO(ticket.toDate)));
      const now = DateTime.now();

      if (!maxDate || maxDate < now) {
        return BookingStatus.done;
      } else {
        return BookingStatus.open;
      }
    } else {
      return BookingStatus.done;
    }
  }
}

export enum BookingStatus {
  open = 'open',
  done = 'done',
  canceled = 'canceled',
}
